import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import settings from '/@/core/settings';
import styles from './styles.module.css';

@autobind
export default class AppLogo extends Component {
    static = {
        className: PropTypes.string,
    };

    render() {
        const { className, ...rest } = this.props;
        return (
            <div
                {...rest}
                className={classNames(styles.root, this.props.className, { [styles.clickable]: Boolean(rest.onClick) })}
            >
                <img className={styles.image} src={settings.app.logo} alt={settings.app.name} />
            </div>
        );
    }
}
